<template>
  <div class="teams-wrapper">
    <div class="tab-options"></div>
    <div class="teams-widget">
      <multipane class="custom-resizer" layout="vertical">
        <div class="teams-list">
          <div class="teams-header">
            <div class="search-add-btn-widget">
              <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input
                  v-model="search_input"
                  type="text"
                  placeholder="Type in to Search…"
                />
              </div>
            </div>
            <div class="team-title-options">
              <h1 class="team-title">All Teams</h1>
              <div class="options">
                <button
                  class="btn-add"
                  v-if="isPermited"
                  @click="addNewDepartment()"
                >
                  Add Department
                  <img src="@/assets/admin-icon/circle-blue-add.svg" />
                </button>
              </div>
            </div>
          </div>

          <div class="teams-body" v-if="isPermited">
            <div
              class="departiment-item"
              v-for="(item, i) in department_data"
              :key="i"
              @dragover="depRowDradOver(item, i)"
            >
              <div
                class="department-header"
                :class="{ active: item.expanded }"
                @click.self="expandDepartment(item, i)"
              >
                <div class="start" @click="expandDepartment(item, i)">
                  <label class="dep-label"
                    >{{ item.name | validate }} |
                    {{ item.teams.length | validate }} Teams</label
                  >
                </div>
                <div class="options">
                  <button>
                    <img
                      v-if="item.expanded"
                      src="@/assets/admin-icon/green-caret-up.svg"
                    />
                    <img v-else src="@/assets/admin-icon/gray-caret-down.svg" />
                  </button>
                  <dropdownMenu>
                    <ul>
                      <li>
                        <a @click.prevent="addNewTeam(item)" href="#"
                          >Add Team</a
                        >
                      </li>
                      <li>
                        <a @click.prevent="updateDepartment(item)" href="#"
                          >Update</a
                        >
                      </li>
                      <li>
                        <app-dialog
                          title="Delete Account"
                          ask="Are you sure you want to permanently delete this ?"
                          yesText="Delete"
                          noText="Cancel"
                          @onComfirm="deleteDepartment(item)"
                        >
                          <a @click.prevent="" href="#">Delete</a>
                        </app-dialog>
                      </li>
                    </ul>
                  </dropdownMenu>
                </div>
              </div>
              <div
                class="department-body"
                v-show="item.expanded && item.teams.length > 0"
              >
                <table class="table-data">
                  <thead class="table-header">
                    <tr>
                      <th class="center">
                        <input type="checkbox" /> Team name
                      </th>
                      <th>Manager</th>
                      <th class="text-center">Members</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <template v-for="(team, index) in item.teams">
                      <tr
                        @dragover="teamRowDradOver($event, team, index)"
                        @dragenter="teamRowDradEnter($event, team, index)"
                        @dragleave="teamRowDradLeave($event, team, index)"
                        @drop="teamRowDradDrop($event, team, index)"
                        :key="index"
                        class="row-data"
                        :class="{ hovered: team.hovered }"
                      >
                        <td @click="selectTeam(item, team)">
                          <div class="profile-content center">
                            <input class="checkbox" type="checkbox" />
                            <div class="profile-alphabet">
                              <span>{{
                                $nameInitials(team.name) | validate
                              }}</span>
                            </div>
                            {{ team.name }}
                          </div>
                        </td>
                        <td @click="selectTeam(item, team)">
                          <span v-if="team.managers.length > 0">{{
                            (team.managers[0].first_name +
                              " " +
                              team.managers[0].last_name)
                              | validate
                          }}</span>
                        </td>
                        <td class="center" @click="selectTeam(item, team)">
                          <span
                            class="team-member"
                            v-if="
                              team.consultants && team.consultants.length > 0
                            "
                          >
                            {{ team.consultants.length | validate }}
                          </span>
                          <span v-else class="team-member">No members</span>
                        </td>
                        <td>
                          <div class="menu">
                            <button @click.prevent="updateTeam(team)">
                              <img
                                src="@/assets/admin-icon/update.svg"
                                alt=""
                              />
                            </button>
                          </div>
                        </td>
                        <td>
                          <div class="menu">
                            <app-dialog
                              title="Delete Account"
                              ask="Are you sure you want to delete this team?"
                              yesText="Delete"
                              noText="Cancel"
                              @onComfirm="deleteTeam(team, item, index)"
                            >
                              <button>
                                <img src="@/assets/admin-icon/delete.svg" />
                              </button>
                            </app-dialog>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div
                v-if="item.expanded && item.teams.length == 0"
                class="department-body"
              >
                <label
                  >No team in this department, you can add one on menu</label
                >
              </div>
            </div>
          </div>

          <!-- For team manager -->

          <div class="teams-body" v-else>
            <div class="departiment-item">
              <div class="department-body" v-if="teams_data.length > 0">
                <table class="table-data">
                  <thead class="table-header">
                    <tr>
                      <th class="center">
                        <input type="checkbox" /> Team name
                      </th>
                      <th>Manager</th>
                      <th class="text-center">Members</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <template v-for="(team, index) in teams_data">
                      <tr
                        @dragover="teamRowDradOver($event, team, index)"
                        @dragenter="teamRowDradEnter($event, team, index)"
                        @dragleave="teamRowDradLeave($event, team, index)"
                        @drop="teamRowDradDrop($event, team, index)"
                        :key="index"
                        class="row-data"
                        :class="{ hovered: team.hovered }"
                      >
                        <td @click="selectTeam(item, team)">
                          <div class="profile-content center">
                            <input class="checkbox" type="checkbox" />
                            <div class="profile-alphabet">
                              <span>{{
                                $nameInitials(team.name) | validate
                              }}</span>
                            </div>
                            {{ team.name }}
                          </div>
                        </td>
                        <td @click="selectTeam(item, team)">
                          <span v-if="team.managers.length > 0">{{
                            (team.managers[0].first_name +
                              " " +
                              team.managers[0].last_name)
                              | validate
                          }}</span>
                        </td>
                        <td class="center" @click="selectTeam(item, team)">
                          <span
                            class="team-member"
                            v-if="
                              team.consultants && team.consultants.length > 0
                            "
                          >
                            {{ team.consultants.length | validate }}
                          </span>
                          <span v-else class="team-member">No members</span>
                        </td>
                        <td>
                          <div class="menu">
                            <button @click.prevent="updateTeam(team)">
                              <img
                                src="@/assets/admin-icon/update.svg"
                                alt=""
                              />
                            </button>
                          </div>
                        </td>
                        <td>
                          <div class="menu">
                            <app-dialog
                              title="Delete Account"
                              ask="Are you sure you want to delete this team?"
                              yesText="Delete"
                              noText="Cancel"
                              @onComfirm="deleteTeam(team, item, index)"
                            >
                              <button>
                                <img src="@/assets/admin-icon/delete.svg" />
                              </button>
                            </app-dialog>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div v-else class="department-body">
                <label>No team available</label>
              </div>
            </div>
          </div>
        </div>
        <multipane-resizer></multipane-resizer>
        <div v-if="team_data" class="teams-details" :style="{ flexGrow: 1 }">
          <div class="team-container-header">
            <div class="teams-header">
              <div class="team-info">
                <h1 class="team-title">{{ team_data.name }}</h1>
                <div class="path">
                  <span>{{ selected_department.name }}</span>
                </div>
              </div>
            </div>
            <div class="search-add-btn-widget">
              <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input
                  v-model="search_member_input"
                  type="text"
                  placeholder="Type in to Search…"
                />
              </div>
            </div>
          </div>

          <div class="team-container-body">
            <table class="table-data" border="0">
              <thead class="table-header">
                <tr>
                  <th><input class="th-checkbox" type="checkbox" /> Name</th>
                  <th>Contact</th>
                  <th v-if="false"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  v-for="(item, index) in team_data.consultants"
                  :key="index"
                  draggable="true"
                  @dragstart="memberRowDradStart($event, item, index)"
                  @dragend="memberRowDragEnd"
                  @drop="memberRowDradDrop($event, team_data, index)"
                >
                  <td>
                    <div class="tb-profile-widget">
                      <input type="checkbox" />
                      <div
                        class="profile-alphabet"
                        v-if="!item.profile_picture"
                      >
                        <span>
                          {{
                            $nameInitials(
                              item.first_name + " " + item.last_name
                            ) | validate
                          }}
                        </span>
                      </div>
                      <img
                        v-else
                        class="profile-image"
                        :src="
                          $fullUrl('images/profiles/' + item.profile_picture)
                        "
                      />
                      <span class="names"
                        >{{
                          (item.first_name + " " + item.last_name) | validate
                        }}
                        <p class="location" v-if="item.profile">
                          {{ item.profile.address | validate }}
                        </p>
                      </span>
                    </div>
                  </td>

                  <td>
                    <p>{{ item.email | validate }}</p>
                    <p v-if="item.profile">
                      {{ item.profile.phone | validate }}
                    </p>
                  </td>

                  <td v-if="false">
                    <dropdownMenu>
                      <ul>
                        <li>
                          <app-dialog
                            title="Remove Member"
                            ask="Are you sure you want to remove this member?"
                            yesText="Delete"
                            noText="Cancel"
                            @onComfirm="removeMember(team_data.id, item.id)"
                          >
                            <a href="#">Remove</a>
                          </app-dialog>
                        </li>
                      </ul>
                    </dropdownMenu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else :style="{ flexGrow: 1 }" class="teams-details">
          <div class="empty-widget">
            <h1>No selected team</h1>
          </div>
        </div>
      </multipane>
    </div>

    <!-- Team Add - Update Modal -->
    <div class="overlay" v-if="show_form">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!form.id">Create a new team</h4>
          <h4 v-else>Update team</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <div class="input-header">
              <label>Team name*</label>
            </div>

            <input
              type="text"
              v-model="form.team_name"
              placeholder="Add team name"
              class="input-form"
            />
          </div>

          <div class="input-group">
            <label>Manager name*</label>
            <searchSelectInput
              url="/company/search/manager"
              :miltiple="true"
              type="site"
              v-model="manager"
              placeholder="Search for manager"
            >
              <template v-slot:result="{ result }">
                <span class="search-contact-item"
                  ><img
                    width="20"
                    v-if="result.profile_picture"
                    :src="$fullUrl('images/profiles/' + result.profile_picture)"
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ result.first_name | validate }}
                  {{ result.last_name | validate }}</span
                >
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-contact-item">
                  <img
                    width="20"
                    v-if="selected.profile_picture"
                    :src="
                      $fullUrl('images/profiles/' + selected.profile_picture)
                    "
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ selected.first_name | validate }}</span
                >
              </template>
            </searchSelectInput>
          </div>

          <div class="input-group">
            <label>Add members</label>
            <searchSelectInput
              url="/search/people"
              :miltiple="true"
              type="site"
              v-model="members"
              placeholder="Search for members..."
            >
              <template v-slot:result="{ result }">
                <span class="search-contact-item"
                  ><img
                    width="20"
                    v-if="result.profile_picture"
                    :src="$fullUrl('images/profiles/' + result.profile_picture)"
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ result.first_name | validate }}
                  {{ result.last_name | validate }}</span
                >
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-contact-item">
                  <img
                    width="20"
                    v-if="selected.profile_picture"
                    :src="
                      $fullUrl('images/profiles/' + selected.profile_picture)
                    "
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ selected.first_name | validate }}</span
                >
              </template>
            </searchSelectInput>
          </div>
          <div class="input-group">
            <label>Description</label>
            <textarea
              type="text"
              v-model="form.description"
              class="input-form"
              placeholder="Team description"
            ></textarea>
          </div>
          <div class="input-group">
            <label>Location</label>
            <map-helper v-model="form.location"></map-helper>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="team_loading"
            @click="submitTeam()"
            class="btn-save"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form = false">Cancel</button>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Department Add - Update Modal -->
    <div class="overlay" v-if="department_show_form">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!form.id">Create a new department</h4>
          <h4 v-else>Update department</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <div class="input-header">
              <label>Department name*</label>
            </div>
            <input
              type="text"
              v-model="department_form.department_name"
              placeholder="Add department name"
              class="input-form"
            />
          </div>

          <div class="input-group">
            <label>Select Manager*</label>
            <searchSelectInput
              url="/company/search/manager"
              :miltiple="true"
              type="site"
              v-model="manager"
              placeholder="Search for manager"
            >
              <template v-slot:result="{ result }">
                <span class="search-contact-item"
                  ><img
                    width="20"
                    v-if="result.profile_picture"
                    :src="$fullUrl('images/profiles/' + result.profile_picture)"
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ result.first_name | validate }}
                  {{ result.last_name | validate }}</span
                >
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-contact-item">
                  <img
                    width="20"
                    v-if="selected.profile_picture"
                    :src="
                      $fullUrl('images/profiles/' + selected.profile_picture)
                    "
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ selected.first_name | validate }}</span
                >
              </template>
            </searchSelectInput>
          </div>

          <div class="input-group">
            <label>Description</label>
            <textarea
              type="text"
              v-model="department_form.description"
              class="input-form"
              placeholder="Team description"
            ></textarea>
          </div>

          <div class="input-group">
            <label>Location</label>
            <map-helper v-model="department_form.location"></map-helper>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="team_loading"
            @click="submitDepartment()"
            class="btn-save"
            >Save</c-button
          >
          <button class="btn-cancel" @click="department_show_form = false">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";

export default {
  name: "teams",
  components: {},
  props: {},
  data: () => {
    return {
      show_form: false,
      form: {
        id: null,
        team_name: "",
        department_id: null,
        managers_added: [],
        managers_removed: [],
        members_added: [],
        members_removed: [],
        description: "",
        location: "",
      },
      department_form: {
        id: null,
        department_name: "",
        managers_added: [],
        managers_removed: [],
        description: "",
        location: "",
      },
      team_loading: false,
      active_tab: "dep",
      manager: {
        added: [],
        removed: [],
      },
      members: {
        added: [],
        removed: [],
      },
      department_data: [],
      department_show_form: false,
      teams_data: [],
      team_data: null,
      search_input: "",
      selected_department: null,
      search_member_input: "",
      dragged_member: null,
      dragged_member_index: null,
      active_department: null,
    };
  },
  mounted() {
    let vm = this;
    vm.getTeamDepData();
  },
  computed: {
    isPermited() {
      let vm = this;
      return vm.$localStorage.get("main_role") != "team-manager";
    },
  },
  watch: {
    search_input(val) {
      let vm = this;
      vm.searchAll(val);
    },
    search_member_input(val) {
      let vm = this;
      vm.searchMember(val);
    },
  },
  methods: {
    deleteDepartment(item) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_DELETE_DEPARTMENT", { id: item.id })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Department have been deleted",
            type: "success",
            duration: 3000,
          });
          vm.getTeamDepData();
        })
        .catch((error) => {});
    },
    updateDepartment(item) {
      let vm = this;
      vm.department_form.id = item.id;
      vm.department_form.department_name = item.name;
      vm.department_form.managers_added = [];
      vm.department_form.managers_removed = [];
      vm.department_form.description = item.description;
      vm.department_form.location = item.location;
      vm.manager = {
        added: [],
        removed: [],
      };
      item.managers.forEach((item) => {
        eventBus.$set(item, "on_update", true);
        vm.manager.added.push(item);
      });
      vm.department_show_form = true;
    },
    submitDepartment() {
      let vm = this;
      // For manager
      vm.department_form.managers_added = vm.manager.added.map((item) => {
        return item.id;
      });
      const rules = {
        department_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Department can not be empty";
          },
        },
        location: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            } else {
              return "Please select department location";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.department_form, rules)) {
        vm.team_loading = true;
        if (!vm.department_form.id) {
          vm.$store
            .dispatch("ORGANIZATION_ADD_NEW_DEPARTMENT", vm.department_form)
            .then((response) => {
              vm.team_loading = false;
              vm.department_show_form = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Department have been added",
                type: "success",
                duration: 3000,
              });
              vm.getTeamDepData();
            })
            .catch((error) => {
              console.error({ error });
              vm.team_loading = false;
            });
        } else {
          // For manager
          vm.department_form.managers_added = vm.manager.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item.id;
            });
          vm.department_form.managers_removed = vm.manager.removed.map(
            (item) => {
              return item;
            }
          );
          vm.$store
            .dispatch("ORGANIZATION_UPDATE_DEPARTMENT", vm.department_form)
            .then((response) => {
              vm.team_loading = false;
              vm.department_show_form = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Department have been updated",
                type: "success",
                duration: 3000,
              });
              vm.getTeamDepData();
            })
            .catch((error) => {
              console.error({ error });
              vm.team_loading = false;
            });
        }
      }
    },
    addNewDepartment() {
      let vm = this;
      vm.manager = {
        added: [],
        removed: [],
      };
      vm.department_form = {
        id: null,
        department_name: "",
        managers_added: [],
        managers_removed: [],
        description: "",
        location: "",
      };
      vm.department_show_form = true;
    },
    getTeamDepData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.teams_data = response.data;
          } else {
            vm.department_data = response.data.map((item, index) => {
              if (vm.active_department == index) {
                eventBus.$set(item, "expanded", true);
              } else {
                eventBus.$set(item, "expanded", false);
              }
              item.teams = item.teams.map((team) => {
                eventBus.$set(team, "hovered", false);
                return team;
              });
              return item;
            });
          }
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    switchType(type) {
      let vm = this;
      vm.active_tab = type;
    },
    updateTeam(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.team_name = item.name;
      vm.form.managers_added = [];
      vm.form.managers_removed = [];
      vm.form.department_id = item.department_id;
      vm.form.members_added = [];
      vm.form.members_removed = [];
      vm.form.description = item.description;
      vm.form.location = item.location;
      vm.manager = {
        added: [],
        removed: [],
      };
      vm.members = {
        added: [],
        removed: [],
      };
      item.managers.forEach((item) => {
        eventBus.$set(item, "on_update", true);
        vm.manager.added.push(item);
      });
      item.consultants.forEach((item) => {
        eventBus.$set(item, "on_update", true);
        vm.members.added.push(item);
      });
      vm.show_form = true;
    },
    deleteTeam(item, department, index) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_DELETE_TEAM", { id: item.id })
        .then((response) => {
          department.teams.splice(index, 1);
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Team have been deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {});
    },
    submitTeam() {
      let vm = this;
      //For consultant
      vm.form.members_added = vm.members.added.map((item) => {
        return item.id;
      });
      // For manager
      vm.form.managers_added = vm.manager.added.map((item) => {
        return item.id;
      });

      const rules = {
        team_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Team can not be empty";
          },
        },
        department_id: {
          run: (value) => {
            if (vm.form.is_in_department && vm.form.is_existing_department) {
              if (value) {
                return false;
              } else {
                return "Something wrong, Reflesh page";
              }
            }
            return false;
          },
        },
        location: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            } else {
              return "Please select team location";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.team_loading = true;

        if (!vm.form.id) {
          vm.$store
            .dispatch("ORGANIZATION_ADD_NEW_TEAM", vm.form)
            .then((response) => {
              vm.team_loading = false;
              vm.show_form = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Team have been added",
                type: "success",
                duration: 3000,
              });
              vm.getTeamDepData();
            })
            .catch((error) => {
              console.error({ error });
              vm.team_loading = false;
            });
        } else {
          // For manager
          vm.form.managers_added = vm.manager.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item.id;
            });
          vm.form.managers_removed = vm.manager.removed.map((item) => {
            return item;
          });

          // For members
          vm.form.members_added = vm.members.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item.id;
            });
          vm.form.members_removed = vm.members.removed.map((item) => {
            return item;
          });
          vm.$store
            .dispatch("ORGANIZATION_UPDATE_TEAM", vm.form)
            .then((response) => {
              vm.team_loading = false;
              vm.show_form = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "Team have been updated",
                type: "success",
                duration: 3000,
              });
              vm.getTeamDepData();
            })
            .catch((error) => {
              console.error({ error });
              vm.team_loading = false;
            });
        }
      }
    },
    addNewTeam(item) {
      let vm = this;
      vm.show_form = true;
      vm.manager = {
        added: [],
        removed: [],
      };
      vm.members = {
        added: [],
        removed: [],
      };
      vm.form = {
        id: null,
        team_name: "",
        crm_department_id: item.id,
        managers_added: [],
        managers_removed: [],
        members_added: [],
        members_removed: [],
        description: "",
        location: "",
      };
    },
    selectTeam(dep, team) {
      let vm = this;
      vm.selected_department = dep;
      vm.getTeamData(team.id);
    },
    getTeamData(team_id) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_GET_TEAM_DATA", {
          id: team_id,
        })
        .then((response) => {
          vm.team_data = response.data;
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    searchAll(query) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_SEARCH_DEPARTMENT_TEAM", { quel: query })
        .then((response) => {
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.teams_data = response.data;
          } else {
            vm.department_data = response.data.map((item) => {
              eventBus.$set(item, "expanded", true);
              return item;
            });
          }
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    removeMember(team_id, member_id) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_TEAM_REMOVE_MEMBER", {
          id: team_id,
          member_id: member_id,
        })
        .then((response) => {
          vm.getTeamData();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Member have been removed",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    searchMember(query) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_SEARCH_TEAM_MEMBER", {
          team_id: team_data.id,
          quel: query,
        })
        .then((response) => {
          vm.team_data.consultants = response.data;
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    memberRowDradStart(e, item, index) {
      let vm = this;
      e.target.className = "";
      e.target.className += "hold";
      vm.dragged_member = item;
      vm.dragged_member_index = index;
    },
    memberRowDragEnd({ target }) {
      let vm = this;
      target.className = "";
    },
    expandDepartment(item, index) {
      let vm = this;
      item.expanded = !item.expanded;
      vm.active_department = index;
    },
    memberRowDradDrop(e, team, index) {
      let vm = this;
      e.preventDefault();
    },
    teamRowDradOver(e, team, index) {
      let vm = this;
      e.preventDefault();
      team.hovered = true;
    },
    teamRowDradEnter({ target }, team, index) {
      let vm = this;
      team.hovered = true;
    },
    teamRowDradLeave({ target }, team, index) {
      let vm = this;
      team.hovered = false;
    },
    teamRowDradDrop(e, team, index) {
      let vm = this;
      e.preventDefault();
      team.hovered = false;
      vm.onMemberMove(team.id, vm.dragged_member.id);
    },
    onMemberMove(team_id, member_id) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_MOVE_TEAM_MEMBER", {
          to_team_id: team_id,
          from_team_id: vm.team_data.id,
          member_id: member_id,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Member have been moved",
            type: "success",
            duration: 3000,
          });
          vm.getTeamDepData();
          vm.getTeamData(vm.team_data.id);
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something wrong while moving member, Try again",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    depRowDradOver(item, index) {
      let vm = this;
      vm.active_department = index;
      if (vm.$localStorage.get("role") == "team-manager") {
        vm.teams_data = vm.teams_data;
      } else {
        vm.department_data = vm.department_data.map((item) => {
          eventBus.$set(item, "expanded", false);
          return item;
        });
      }
      item.expanded = true;
    },
    depRowDradLeave(item) {
      item.expanded = false;
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.teams-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;
  .teams-widget {
    height: 100%;
    position: relative;
    .custom-resizer {
      height: 100%;
    }
    .teams-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-width: calc(100% - 550px);
      width: 100%;
      .teams-header {
        .search-add-btn-widget {
          background: #fff;
          padding: 15px 10px;
          padding-bottom: 0px;
          display: grid;
          grid-column-gap: 20px;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          .search-widget {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;
            img {
              width: 25px;
              height: 25px;
            }
            input {
              height: 43px;
              width: 100%;
              padding-left: 15px;
              outline: none;
              border: none;
            }
          }
          .add-btn {
            width: 191px;
            height: 45px;
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              margin-left: 10px;
            }
          }
        }
        .team-title-options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          padding: 10px 10px;
          margin-bottom: -3px;
          height: 70px;
          .team-title {
            font-size: 20px;
            font-weight: 800;
          }
          .options {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btn-add {
              background: #0884af;
              border-radius: 5px;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-left: 16px;
            }
          }
        }
        .team-tab {
          display: grid;
          grid-template-columns: 50% 50%;
          .tab {
            padding: 21px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active {
              background: #fff;
              border-bottom: 2px solid #1ba5a4;
            }
          }
        }
      }
      .teams-body {
        background: #fff;
        padding: 10px 10px;
        height: calc(87vh - 70px);
        overflow-y: auto;
        .departiment-item {
          margin-bottom: 5px;
          .department-header {
            height: 40px;
            background: #e7e7e7;
            align-items: center;
            display: flex;
            padding: 0px 10px;
            border-radius: 5px;
            justify-content: space-between;
            cursor: pointer;
            &.active {
              background: #d1eded;
              .start {
                width: 99%;
                cursor: pointer;
                .dep-label {
                  color: #1ba5a4;
                  font-size: 14px;
                }
              }
            }
            .start {
              width: 99%;
              cursor: pointer;
              .dep-label {
                color: rgb(95, 95, 95);
                font-size: 14px;
              }
            }
            .options {
              display: flex;
              align-items: center;
              justify-content: space-between;
              button {
                img {
                  width: 15px;
                }
              }
            }
          }
          .department-body {
            padding-left: 15px;
            padding-top: 5px;
            .table-data {
              border-collapse: collapse;
              border-spacing: 0;
              tr {
                &.row-data {
                  background: #efefef;
                }
                &.hovered {
                  background: #d1eded;
                }
                &:hover {
                  background: rgb(248, 248, 248);
                  cursor: pointer;
                }

                th {
                  border-bottom: none;
                  padding: 10px 3px !important;
                  &.center {
                    display: flex;
                    align-content: center;
                    input {
                      position: relative;
                      top: 0px;
                      margin-right: 5px;
                      margin: 0px 20px;
                    }
                  }
                  &.text-center {
                    text-align: center;
                  }
                }
                td {
                  .checkbox {
                    margin: 0px 20px;
                  }
                  .profile-alphabet {
                    margin-right: 5px;
                    height: 30px !important;
                    width: 30px !important;
                    background: #1ba5a4;
                    span {
                      font-size: 10px;
                      color: #fff;
                    }
                  }
                  .menu {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    button {
                      padding: 0px;
                      position: relative;
                      left: -3px;
                      img {
                        width: 15px;
                      }
                    }
                  }
                  &:first-child {
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                  }
                  &:last-child {
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                  }
                  text-align: left;
                  border-bottom: none;
                  padding: 8px 3px;
                  font-size: 13px;
                  color: rgb(28, 28, 28);
                  border-bottom: 5px solid #fff;
                  &.center {
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
    .teams-details {
      width: 400px;
      min-width: 400px;
      max-width: 550px;
      display: flex;
      padding-right: 5px;
      flex-direction: column;
      height: 100%;
      background: #fff;
      border-radius: 5px;
      .empty-widget {
        display: flex;
        align-content: center;
        justify-content: center;
        h1 {
          font-size: 20px;
          color: #ddd;
          margin-top: 200px;
        }
      }
      .team-container-header {
        display: flex;
        flex-direction: column;
        height: 131px;
        .teams-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 10px;
          padding-bottom: 0px;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          .team-title {
            font-size: 20px;
            font-weight: 800;
            margin: 0px;
          }
          .options {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btn-add {
              background: #0884af;
              border-radius: 5px;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-left: 16px;
            }
          }
        }
        .search-add-btn-widget {
          background: #fff;
          padding: 15px 10px;
          padding-bottom: 0px;
          display: grid;
          grid-column-gap: 20px;

          .search-widget {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;
            img {
              width: 25px;
              height: 25px;
            }
            input {
              height: 43px;
              width: 100%;
              padding-left: 15px;
              outline: none;
              border: none;
            }
          }
          .add-btn {
            width: 191px;
            height: 45px;
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              margin-left: 10px;
            }
          }
        }
      }
      .team-container-body {
        overflow-y: auto;
        height: calc(100% - 131px);
        .table-data {
          width: 100%;
          border-collapse: collapse;
          border-spacing: 0;
          .th-checkbox {
            position: relative;
            top: 2px;
          }
          tr {
            &.hold {
              opacity: 0.3;
            }
            th,
            td {
              text-align: left;
              padding: 10px;
              border: none;
            }
            td {
              background: #f7f7f7;
              border-bottom: 4px solid #fff;
              p {
                margin: 0px;
              }
              .tb-profile-widget {
                display: flex;
                align-items: center;
                .profile-alphabet {
                  height: 30px !important;
                  width: 30px !important;
                  background: #1ba5a438;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #1ba5a4;
                  font-size: 10px !important;
                  margin-right: 10px;
                  margin-left: 4px;
                  span {
                    font-size: 10px !important;
                  }
                }
                .profile-image {
                  height: 30px !important;
                  width: 30px !important;
                  background: #1ba5a438;
                  border-radius: 50%;
                  margin-right: 10px;
                  margin-left: 4px;
                }
                .names {
                  margin-left: 0px;
                  .location {
                    color: rgb(170, 170, 170);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 20px;
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
